<div class="blue-border-top tab-content mat-elevation-z3 has-page-title">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="page-header">
    <h2 class="page-title-2">
      Select School
    </h2>
    <a (click)="onClose()" class="has-image" title="Close Select School Card" *ngIf="showCloseButton"
      href="javascript:void(0);">
      <img src=" ../../../../assets/images/close-icon.png" />
    </a>
  </div>
  <mat-divider></mat-divider>
  <br />
  <form (ngSubmit)="selectSchool()">
    <div fxLayout="row" fxLayoutAlign="center center" class="select-school-box">
      <mat-form-field fxFlex="50" class="uhc-block">
        <mat-label>Let's start with your Client Name or Client Number</mat-label>
        <input autoFocus matInput [formControl]="clientControl" name="client" [matAutocomplete]="clientAutocomplete">
        <mat-autocomplete autoActiveFirstOption #clientAutocomplete="matAutocomplete" [displayWith]="displayFn"
          (closed)="closed()">
          <mat-option *ngFor="let client of filteredClients | async" [value]="client">
            {{client.Name}} {{client.Number ? ' (' + client.Number + ')' : ''}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <button class="uhc-button uhc-primary select-school-button">Submit</button>
    </div>
  </form>
</div>